import { DatagridResponsive } from "@/components/datagrid-base";
import { TDatagridData } from "@/components/datagrid-base/types";
import { Modal } from "@/components/modal-base";
import { Page } from "@/components/page-base";
import { EmbaixadorService } from "@/modules/embaixador/services";
import { parseMoney } from "@/utils/parseMoney";
import { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { BtnContainer, DgContainer, InputContainer } from "./styles";
import { toast } from "react-toastify";
import { Dialog, DialogActions, DialogTitle } from "@mui/material";
import theme from "@/styles/theme";
import { useNavigationContext } from "@/contexts";

interface IWithdrawalModalProps {
  modal: boolean;
  toggleModal: () => void;
  balance: number;
}
type Payment = {
  amount: number;
  status: string;
  createdAt: string;
  id: number;
};

export const WithdrawalModal: React.FC<IWithdrawalModalProps> = ({
  modal,
  toggleModal,
  balance
}) => {
  const [fetchWithdraw, setFetchWithdraw] = useState<boolean>(false);
  const [data, setData] = useState<Payment[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [count, setCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const { rowsPerPage } = useNavigationContext();
  const [amount, setAmount] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    const fetchWithdraw = async () => {
      await EmbaixadorService.getHistoryWithdrawal(page, rowsPerPage).then(
        (response) => {
          setData(response.data);
          setCount(response.meta.total);
          if (response.data.purchases && response.data.purchases.length > 0) {
            setData(response.data.purchases);
          }
          setLoading(false);
        }
      );
    };
    fetchWithdraw();
  }, [fetchWithdraw, rowsPerPage, page]);

  const navigateTable = (newPage: string) => {
    setPage(Number(newPage));
  };
  const parseStatus = (status: string): string => {
    switch (status) {
      case "PENDING":
        return "Aguardando pagamento";
      case "CONFIRMED":
        return "Compra realizada";
      case "INACTIVE":
        return "Cadastro efetuado";
      default:
        return status;
    }
  };
  const createRow = (records: Payment[]): TDatagridData[] => {
    return records.map((record) => ({
      valor: parseMoney(record.amount ?? 0),
      "Data da solicitação": record.createdAt,
      situacao: parseStatus(record.status),
      id: record.id
    }));
  };
  const handleSubmitWithdrawal = async () => {
    setIsSubmitting(true);
    try {
      const embaixador = await EmbaixadorService.withdrawal({
        amount: Number(amount)
      });

      if (embaixador.success) {
        toast.success("Solicitação de saque realizada!");
        setAmount("");
        setFetchWithdraw((prev) => !prev);
        toggleModal();
      } else {
        toast.info("Já existe um saque em andamento!");
      }
    } catch (error) {
      toast.error("Ocorreu um erro ao processar o saque");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDialog = () => {
    setOpenDialog((prev) => !prev);
  };

  return (
    <Modal.Root open={modal} onClose={toggleModal} maxWidth="900px">
      <Modal.Header justifyContent="end">
        <Modal.HeaderText text={"Histórico"} />
        <Modal.Icon
          icon="Close"
          cursor="pointer"
          onClick={toggleModal}
          iconColor="black"
        />
      </Modal.Header>
      <Modal.Content>
        <span style={{ fontSize: 14 }}> Saque mínimo R$ 50,00</span>
        <InputContainer>
          <NumericFormat
            value={amount}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            allowLeadingZeros={true}
            className="max-w-sm w-full bg-white rounded border p-2"
            prefix="R$ "
            placeholder="Digite um valor para saque"
            onValueChange={(values) => {
              setAmount(values.value);
            }}
          />
          <BtnContainer>
            <Page.Button
              label={isSubmitting ? "Processando..." : "Sacar"}
              disabled={balance < 50 || Number(amount) < 50 || isSubmitting}
              onClick={handleDialog}
            />
          </BtnContainer>
        </InputContainer>

        <Dialog
          fullScreen={false}
          open={openDialog}
          onClose={handleDialog}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle>
            {Number(amount) <= balance
              ? `Confirmar saque no valor de R$ ${amount} ?`
              : "Saldo insuficiente!"}
          </DialogTitle>
          <DialogActions>
            {Number(amount) <= balance ? (
              <>
                <Page.Button
                  onClick={handleSubmitWithdrawal}
                  disabled={isSubmitting}
                  label="Confirmar"
                  bgColor={theme.colors.palete.green}
                  hoverBgcolor={theme.colors.palete.greenHover}
                  color="white"
                />
                <Page.Button
                  onClick={handleDialog}
                  label="Fechar"
                  bgColor={theme.colors.palete.red}
                  hoverBgcolor={theme.colors.palete.redHover}
                  color="white"
                />
              </>
            ) : (
              <Page.Button onClick={handleDialog} label="Fechar" />
            )}
          </DialogActions>
        </Dialog>
        <DgContainer>
          <DatagridResponsive.Combo
            headers={[
              { field: "Valor", width: "15vw" },
              { field: "Data de consulta", width: "15vw" },
              { field: "Situação", width: "10vw" }
            ]}
            count={count}
            rowHeader="valor"
            data={createRow(data)}
            navigateTable={navigateTable}
            loading={loading}
            page={page}
            disableHeight
          />
        </DgContainer>
      </Modal.Content>
    </Modal.Root>
  );
};
